import { ElectronApi } from '@/services/electron.api';
import { emitter, EventType } from '@/utils/emitter.utils';
import { getWebBuildTime } from '@/utils/version.utils';
import { Modal } from 'ant-design-vue';
import dayjs from 'dayjs';
import { onBeforeUnmount, ref } from 'vue';
import { isHistoryMode } from './use-version-history';

const newVersion = ref(false);
const newVersionBuildtime = ref('');
const timer = ref(0);
const timer2 = ref(0);

export const useWebVersion = () => {
  const getLastestBuildTime = async () => {
    try {
      const url = window.location.href;
      const res = await window.fetch(url, { cache: 'no-store' });
      const content = await res.text();
      const reg = /(?<=meta name="build-time" content=").{1,}(?=".*)/;
      const _buildTime = content.match(reg)?.[0];
      return _buildTime;
    } catch (error) {
      console.log(error);
    }
  };
  /**
   * 返回是否应该更新版本
   * @returns
   */
  const _checkVersion = async () => {
    if (import.meta.env.DEV) return false;
    // 历史版本模式下不检查更新（仅当次会话）
    if (isHistoryMode.value) return false;
    // 如果已有版本，则不需要检查了
    if (newVersion.value) return true;
    const buildTime = getWebBuildTime();
    if (!buildTime) return false;
    try {
      const _buildTime = await getLastestBuildTime();
      if (_buildTime) {
        newVersionBuildtime.value = _buildTime;
        newVersion.value = dayjs(_buildTime).isAfter(buildTime);
        return newVersion.value;
      }
    } catch (error) {
      console.log(error);
    }
    return false;
  };

  /**
   * 返回是否有新版本
   * @param update 是否提示更新
   */
  const checkVersion = async (showModal = false) => {
    const lastest = await _checkVersion();
    if (lastest && showModal) {
      emitter.emit(EventType['modal:open-new-version'], {
        newVersionBuildtime: newVersionBuildtime.value
      });
    }
    return lastest;
  };

  const reloadWeb = () => {
    ElectronApi.reload();
  };

  const checkEditorVersion = () => {
    if (!globalThis.window.electron?.versionType) {
      Modal.info({
        title: '工具版本过旧，已不支持！',
        content: '请联系小米获取最新工具包，否则表盘制作会有问题！',
        okText: '知道了',
        zIndex: 999
      });
      return false;
    } else {
      return true;
    }
  };

  const autoCheckVersion = () => {
    if (!checkEditorVersion()) return;
    if (timer.value) window.cancelIdleCallback(timer.value);
    timer.value = window.requestIdleCallback(() => {
      if (timer2.value) window.clearTimeout(timer2.value);
      timer2.value = window.setTimeout(() => {
        checkVersion(true);
      }, 2000);
    });
  };

  onBeforeUnmount(() => {
    if (timer.value) window.cancelIdleCallback(timer.value);
    if (timer2.value) window.clearTimeout(timer2.value);
  });

  return {
    getBuildTime: getWebBuildTime,
    getLastestBuildTime,
    reloadWeb,
    checkVersion,
    autoCheckVersion,
    checkEditorVersion
  };
};
